/**
 * Web Vitals metric types from Next.js
 */
export type MetricType = "FCP" | "LCP" | "CLS" | "FID" | "TTFB" | "INP";

/**
 * Web Vitals metric structure
 */
export type Metric = {
  id: string;
  name: MetricType;
  value: number;
  rating: "good" | "needs-improvement" | "poor";
  delta: number;
  navigationType: "navigate" | "reload" | "back-forward" | "prerender";
};

/**
 * Generation timing metrics
 */
export type GenerationMetric = {
  startTime: number;
  responseTime?: number;
  duration?: number;
  status: "started" | "responded" | "completed" | "failed";
};

/**
 * Performance thresholds for perf-001 (page load < 3s)
 * Using LCP (Largest Contentful Paint) as primary metric
 */
export const PAGE_LOAD_THRESHOLD_MS = 3000;

/**
 * Performance thresholds for perf-002 (generation starts < 5s)
 */
export const GENERATION_START_THRESHOLD_MS = 5000;

/**
 * Web Vitals thresholds (Google's recommendations)
 */
export const WEB_VITALS_THRESHOLDS = {
  LCP: { good: 2500, needsImprovement: 4000 }, // Largest Contentful Paint
  FCP: { good: 1800, needsImprovement: 3000 }, // First Contentful Paint
  TTFB: { good: 800, needsImprovement: 1800 }, // Time to First Byte
  CLS: { good: 0.1, needsImprovement: 0.25 }, // Cumulative Layout Shift
  FID: { good: 100, needsImprovement: 300 }, // First Input Delay
  INP: { good: 200, needsImprovement: 500 }, // Interaction to Next Paint
} as const;
